import React, { FC } from 'react';
import { Box } from '@mui/material';


export const AddProduct:FC = () => {

  return (
    <Box>
        Dodawanie Produktów
    </Box>
  );
};